//375px
import imgOne375 from '../assets/images/landing/menu-preview/4cheese.webp'
import imgTwo375 from '../assets/images/landing/menu-preview/prosciutto.webp'
import imgThree375 from '../assets/images/landing/menu-preview/diavolo.webp'
import imgFour375 from '../assets/images/landing/menu-preview/salami.webp'
import imgFive375 from '../assets/images/landing/menu-preview/margherita.webp'
import imgSix375 from '../assets/images/landing/menu-preview/mare.webp'
//700px
import imgOne700 from '../assets/images/landing/menu-preview/4cheese.webp'
import imgTwo700 from '../assets/images/landing/menu-preview/prosciutto.webp'
import imgThree700 from '../assets/images/landing/menu-preview/diavolo.webp'
import imgFour700 from '../assets/images/landing/menu-preview/salami.webp'
import imgFive700 from '../assets/images/landing/menu-preview/margherita.webp'
import imgSix700 from '../assets/images/landing/menu-preview/mare.webp'
//1440
import imgOne1440 from '../assets/images/landing/menu-preview/4cheese.webp'
import imgTwo1440 from '../assets/images/landing/menu-preview/prosciutto.webp'
import imgThree1440 from '../assets/images/landing/menu-preview/diavolo.webp'
import imgFour1440 from '../assets/images/landing/menu-preview/salami.webp'
import imgFive1440 from '../assets/images/landing/menu-preview/margherita.webp'
import imgSix1440 from '../assets/images/landing/menu-preview/mare.webp'

const pizzaMenuPreview = [
    {
        id: 1,
        img375: imgOne375,
        img700: imgOne700,
        img1440: imgOne1440,
        name: 'Quattro Formaggi',
        price: 14.0,
        currency: '€',
        description:
            'Ein cremiges Meisterwerk, das auf der Zunge zergeht – verfeinert mit einer reichhaltigen Mischung aus vier erlesenen Käsesorten. Ein echter Genuss für Käseliebhaber!',
    },
    {
        id: 2,
        img375: imgTwo375,
        img700: imgTwo700,
        img1440: imgTwo1440,
        name: 'Prosciutto und Ruccola',
        price: 14.0,
        currency: '€',
        description:
            'Eine elegante Kombination aus hauchdünn geschnittenem Prosciutto und frischem, pfeffrigem Rucola auf einem knusprig-goldenen Boden. Jeder Biss ein Stück italienische Perfektion!',
    },
    {
        id: 3,
        img375: imgThree375,
        img700: imgThree700,
        img1440: imgThree1440,
        name: 'Diavola Pizza',
        price: 13.0,
        currency: '€',
        description:
            'Für alle, die es feurig mögen! Belegt mit scharfer Salami, würziger Tomatensauce und einem Hauch Chili – nichts für schwache Nerven.',
    },
    {
        id: 4,
        img375: imgFour375,
        img700: imgFour700,
        img1440: imgFour1440,
        name: 'Salami Pizza',
        price: 13.0,
        currency: '€',
        description:
            'Der Traum aller Fleischliebhaber! Herzhaft gewürzte Salami auf reichhaltiger Tomatensauce und zartschmelzendem Mozzarella – purer Genuss in jeder Scheibe.',
    },
    {
        id: 5,
        img375: imgFive375,
        img700: imgFive700,
        img1440: imgFive1440,
        name: 'Margherita Pizza',
        price: 10.0,
        currency: '€',
        description:
            'Ein zeitloser Klassiker! Saftige Tomaten, cremiger Mozzarella und frisches Basilikum auf knusprig-dünnem Boden – der echte Geschmack Neapels.',
    },
    {
        id: 6,
        img375: imgSix375,
        img700: imgSix700,
        img1440: imgSix1440,
        name: 'Mare Pizza',
        price: 16.0,
        currency: '€',
        description:
            'Ein Highlight für alle Meeresfrüchteliebhaber! Frische Aromen aus dem Ozean treffen auf einen goldenen, knusprigen Boden – jeder Biss voller mediterraner Leichtigkeit und Küstenflair.',
    },
]

export default pizzaMenuPreview;